module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-49.37476c06.svg";